import axios from "axios";

export default {
  state: {
    aiConversation: [],
    pastConversations: [],
    conversationSession: null,
  },
  getters: {
    aiConversation: (state) => state.aiConversation,
    getPastConversations: (state) => state.pastConversations,
    getConversationSession: (state) => state.conversationSession,
  },
  mutations: {
    setConversation(state, query) {
      state.aiConversation.push(query);
    },
    setPastConversations(state, conversations) {
      state.pastConversations = conversations;
    },
    clearConversation(state) {
      state.aiConversation = [];
    },
    setConversationSession(state, session) {
      state.conversationSession = session;
    },
  },
  actions: {
    createIndex({ commit, dispatch }, newFaq) {
      console.log("New Faq coming: ", newFaq);
      let strapiConfig = {
        method: "post",
        url: "https://cms.elpaso.arsconnect.com/faqs",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(newFaq),
      };
      console.log("Strapi Config: ", strapiConfig);
      axios
        .request(strapiConfig)
        .then((response) => {
          console.log("Entry Created: ", response.data);
          let config = {
            url: "https://project-bluebox.uc.r.appspot.com/api/add",
            method: "post",
            data: newFaq,
          };
          axios
            .request(config)
            .then((response) => {
              console.log(response);
              if (response.status == 201) {
                console.log("FAQ updated successfully");
                commit("setFaqs", newFaq);
                dispatch("showSnackBar", {
                  text: "FAQ added successfully.",
                  color: "success",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log("Error: ", error);
        });
    },
    updateIndex({ getters, commit, dispatch }, faqDetails) {
      //update FAQ first then update the index
      console.log("FAQ details: ", faqDetails);
      let strapiConfig = {
        method: "put",
        url: "https://cms.elpaso.arsconnect.com/faqs/" + faqDetails.id,
        headers: {
          "Content-Type": "application/json",
        },
        data: faqDetails,
      };
      axios
        .request(strapiConfig)
        .then((response) => {
          console.log("Entry Updated: ", response.data);
          let config = {
            url: "https://project-bluebox.uc.r.appspot.com/api/update",
            method: "post",
            data: faqDetails,
          };

          axios
            .request(config)
            .then((response) => {
              console.log(response);
              if (response.status == 201) {
                console.log("FAQ updated successfully");
                // First remove the older one and then add the new one
                let index = getters.getFaqs.findIndex(
                  (faq) => faq.id == faqDetails.id
                );
                if (index !== -1) {
                  getters.getFaqs.splice(index, 1);
                }
                commit("setFaqs", faqDetails);
                dispatch("showSnackBar", {
                  text: "FAQ updated successfully.",
                  color: "success",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log("Error updating entry: ", error);
        });

      // Update the index
    },
    saveConversationToStrapi({ commit, getters }, conversation) {
      console.log("conversation", conversation);
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://cms.elpaso.arsconnect.com/ai-conversations",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          sessionId: getters.getConversationSession,
          conversation: conversation,
          userId: getters.userId,
        },
      };
      axios
        .request(config)
        .then((response) => {
          console.log("response", response);
        })
        .catch((error) => {
          console.log("error adding conversation to strapi", error);
        });
    },
    pullPastConversations({ commit, getters }) {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url:
          "https://cms.elpaso.arsconnect.com/ai-conversations?userId=" +
          getters.userId +
          "&_limit=-1",
        headers: {
          "Content-Type": "application/json",
        },
      };
      console.log("Conversation pull config", config);
      axios
        .request(config)
        .then((response) => {
          console.log("response", response.data);
          const merged = Object.values(
            response.data.reduce((acc, item) => {
              const { sessionId, userId, conversation } = item;
              if (!acc[sessionId]) {
                acc[sessionId] = {
                  sessionId,
                  userId,
                  conversation: [],
                };
              }

              acc[sessionId].conversation.push(conversation);
              return acc;
            }, {})
          );
          console.log("What is merged", merged);
          commit("setPastConversations", merged);
        })
        .catch((error) => {
          console.log("error adding conversation to strapi", error);
        });
    },
  },
};
